import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { DatatableComponent } from './datatable/datatable.component';
import { MaterialModule } from '../material/material.module';
import { FormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask';
import { ValidationModule } from '../validation/validation.module';
import { RowDetailVisiblePipe } from './row-detail-visible-pipe';
import { UtilityModule } from '../utility/utility.module';
import { DatatableFilterComponent } from './datatable-filter/datatable-filter.component';

@NgModule({
  declarations: [DatatableComponent, DatatableFilterComponent, RowDetailVisiblePipe],
  imports: [
    CommonModule,
    NgxDatatableModule,
    MaterialModule,
    FormsModule,
    UtilityModule,
    ValidationModule,
    NgxMaskModule.forRoot(),
  ],
  exports: [DatatableComponent],
})
export class DatatableModule {}
